import React from 'react'

import { Box, Display, FlexDirection, Heading5, Overflow } from '@gousto-internal/citrus-react'

import { IngredientPill } from './IngredientPill'
import { AlternativeOptions } from '../../types'
import { RecipeUUID } from '@library/menu-service'

type RecipeOptionsIngredientsProps = {
  recipeUuid: RecipeUUID
  options: AlternativeOptions['options']
  ingredientSlots: AlternativeOptions['ingredientSlots']
  onChangeSelection: (id: RecipeUUID) => void
}

export const RecipeOptionsIngredients = ({
  recipeUuid,
  options,
  ingredientSlots,
  onChangeSelection,
}: RecipeOptionsIngredientsProps) => {
  return (
    <Box
      paddingV={4}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gap={5}
      style={{ cursor: 'default' }}
    >
      {ingredientSlots?.map((slot) => (
        <Box key={slot.id}>
          <Heading5>
            {`Choose from ${slot.values.length} ${slot.name} option${
              slot.values.length === 1 ? '' : 's'
            }:`}
          </Heading5>
          <Box
            display={Display.Flex}
            flexDirection={FlexDirection.Row}
            gap={3}
            paddingV={2}
            overflowX={[Overflow.Scroll, Overflow.Visible]}
            wrap={[false, true]}
          >
            {slot.values.map((value) => (
              <IngredientPill
                key={value.id}
                recipeUuid={recipeUuid}
                options={options}
                slotValue={value}
                slotId={slot.id}
                onChangeSelection={onChangeSelection}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
